<template>
    <div :class="rootClasses">
        <div id="plans-loop" :class="loopClasses" v-for="plan in plans">
            <plan
                :plan="plan"
                :section="section"
                :is-selected="isSelected(plan.id)"
                @planWasSelected="planWasSelectedListener"
            ></plan>
        </div>
    </div>
</template>
<script>
import Plan from './Plan';

export default {
    props: ['rootClasses', 'loopClasses', 'section'],

    components: {
        Plan,
    },

    created() {
        this.getPlans();
    },

    data() {
        return {
            plans: {},
            selectedPlan: '',
        };
    },

    methods: {
        getClassColorFor(plan) {
            return plan.id === 'anual' ? 'red' : 'blue';
        },

        async getPlans() {
            let response = await axios.get('/api/plans');

            this.plans = response.data.data;
        },

        planWasSelectedListener(plan) {
            this.selectedPlan = plan;
            this.$emit('bubbleUpPlanSelected', plan);
        },

        isSelected(id) {
            return this.selectedPlan.id === id;
        },
    },
};
</script>
